import { Directive, TemplateRef } from '@angular/core';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[dynamic-template]'
})
export class DynamicTemplateDirective {
  constructor(public templateRef: TemplateRef<any>) { }
}
